import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Form,
  Row,
  Col,
  Spinner,
  ListGroup,
} from "react-bootstrap";
import ReactExport from "react-export-excel";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarConfig from "../../components/SidebarConfig";
import {
  saveAdminSetting,
  getAdminSetting,
  editAdminSetting,
  exportDataToExcel,
  updateStateAdminSettings,
} from "../../redux/adminSettings/actions";
import moment from "moment";

const AdminSettings = () => {
  //States
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  //Excel
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  //Redux
  const dispatch = useDispatch();
  const saveLoading = useSelector((store) => store.adminSettings.saveLoading);
  const loading = useSelector((store) => store.adminSettings.loading);
  const loaderData = useSelector((store) => store.adminSettings.loaderExcel);
  const dates = useSelector((store) => store.adminSettings.dates);
  const data = useSelector((store) => store.adminSettings.data);

  //Methods

  useEffect(() => {
    dispatch(getAdminSetting());
    dispatch(exportDataToExcel());
  }, [dispatch]);

  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    const odata = {
      fecha_inicio: e.target.startDate.value,
      fecha_fin: e.target.endDate.value,
    };
    if (dates && dates.id) {
      dispatch(editAdminSetting(odata, dates.id));
    } else {
      dispatch(saveAdminSetting(odata));
    }
  };

  const onUpdateStateAdminSettings = (tipo, data) =>{
    dispatch(updateStateAdminSettings({tipo_actualizacion:tipo,lista:data}))

  }
  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Card className="border-0">
          <Card.Body>
            <div className="my-4">
              <h5 className="font-weight-bold text-uppercase">
                Exportar archivos a excel
              </h5>
              <p>
                Se generará archivos de excel con los datos editables de los
                usuarios para la carga a SAP
              </p>
              {loaderData ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : (
                data && (
                  <ListGroup variant="flush">
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                      <h6 className="m-0">Exportar contactos</h6>
                      <ExcelFile
                        element={
                          <Button
                            disabled={                              
                              !data.Actualizacion_Contacto ||                              
                              data?.Actualizacion_Contacto?.length === 0
                            }
                            variant="primary"
                            size="sm"
                            onClick={()=> onUpdateStateAdminSettings("contacto",data.Actualizacion_Contacto)} 
                          >
                            Exportar
                          </Button>
                        }
                      >
                        {data.Actualizacion_Contacto && (
                          <ExcelSheet
                            data={data.Actualizacion_Contacto}
                            name="Contactos"
                          >
                            <ExcelColumn
                              label="Código de empleado"
                              value="codigo_empleado"
                            />
                            <ExcelColumn
                              label="Info tipo"
                              value={() => "0105"}
                            />
                            <ExcelColumn label="Subtipo" value="subtipo" />
                            <ExcelColumn label="Valor" value="valor" />
                            <ExcelColumn label="Fecha" value="fecha" />
                          </ExcelSheet>
                        )}
                      </ExcelFile>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                      <h6 className="m-0">Exportar dependientes</h6>
                      <ExcelFile
                        element={
                          <Button
                            disabled={
                              !data.Actualizacion_Dependiente ||
                              data?.Actualizacion_Dependiente?.length === 0
                            }
                            variant="primary"
                            size="sm"
                            onClick={()=> onUpdateStateAdminSettings("dependiente",data.Actualizacion_Dependiente)} 
                          >
                            Exportar
                          </Button>
                        }
                      >
                        {data.Actualizacion_Dependiente && (
                          <ExcelSheet
                            data={data.Actualizacion_Dependiente}
                            name="Dependientes"
                          >
                            <ExcelColumn
                              label="Código de empleado"
                              value="codigo_empleado"
                            />
                            <ExcelColumn
                              label="Info tipo"
                              value={() => "0021"}
                            />
                            <ExcelColumn label="Subtipo" value="subtipo" />
                            <ExcelColumn
                              label="De"
                              value={(col) =>
                                moment(col.de).format("DD.MM.YYYY")
                              }
                            />
                            <ExcelColumn
                              label="Hasta"
                              value={(col) =>
                                moment(col.hasta).format("DD.MM.YYYY")
                              }
                            />
                            <ExcelColumn
                              label="Número de familiar"
                              value="secuencia"
                            />
                            <ExcelColumn label="Nombres" value="nombre" />
                            <ExcelColumn
                              label="Primer apellido"
                              value="primer_apellido"
                            />
                            <ExcelColumn
                              label="Segundo apellido"
                              value="segundo_apellido"
                            />
                            <ExcelColumn
                              label="Apellido soltera"
                              value="apellido_soltera"
                            />
                            <ExcelColumn label="Sexo" value="genero" />
                            <ExcelColumn
                              label="Fecha de nacimiento"
                              value={(col) =>
                                moment(col.fecha_nacimiento).format(
                                  "DD.MM.YYYY"
                                )
                              }
                            />
                            <ExcelColumn
                              label="Ciudad de nacimiento"
                              value="ciudad_nacimiento"
                            />
                            <ExcelColumn
                              label="Pais de nacimiento"
                              value="pais_nacimiento"
                            />
                            <ExcelColumn
                              label="Nacionalidad"
                              value="nacionalidad"
                            />
                            <ExcelColumn
                              label="Número de identidad"
                              value="identidad"
                            />
                            <ExcelColumn
                              label="Dependiente"
                              value="dependiente"
                            />
                            <ExcelColumn label="Fecha" value="fecha" />
                          </ExcelSheet>
                        )}
                      </ExcelFile>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                      <h6 className="m-0">Exportar domicilios</h6>
                      <ExcelFile
                        element={
                          <Button
                            disabled={
                              !data.Actualizacion_Domicilio ||
                              data?.Actualizacion_Domicilio?.length === 0
                            }
                            variant="primary"
                            size="sm"
                            onClick={()=> onUpdateStateAdminSettings("domicilio",data.Actualizacion_Domicilio)} 
                          >
                            Exportar
                          </Button>
                        }
                      >
                        {data.Actualizacion_Domicilio && (
                          <ExcelSheet
                            data={data.Actualizacion_Domicilio}
                            name="Domicilios"
                          >
                            <ExcelColumn
                              label="Código de empleado"
                              value="codigo_empleado"
                            />
                            <ExcelColumn
                              label="Info tipo"
                              value={() => "0006"}
                            />
                            <ExcelColumn label="Subtipo" value="subtipo" />
                            <ExcelColumn label="De" value="de" />
                            <ExcelColumn label="Hasta" value="hasta" />
                            <ExcelColumn label="Colonia" value="colonia" />
                            <ExcelColumn label="Colonia" value="colonia" />
                            <ExcelColumn label="Región" value="region" />
                            <ExcelColumn label="Teléfono" value="telefono" />
                            <ExcelColumn
                              label="Tipo de residencia"
                              value="tipo_residencia"
                            />
                            <ExcelColumn label="Fecha" value="fecha" />
                          </ExcelSheet>
                        )}
                      </ExcelFile>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                      <h6 className="m-0">Exportar educación</h6>
                      <ExcelFile
                        element={
                          <Button
                            disabled={
                              !data.Actualizacion_Educacion ||
                              data?.Actualizacion_Educacion?.length === 0
                            }
                            variant="primary"
                            size="sm"
                            onClick={()=> onUpdateStateAdminSettings("educacion",data.Actualizacion_Educacion)} 
                          >
                            Exportar
                          </Button>
                        }
                      >
                        {data.Actualizacion_Educacion && (
                          <ExcelSheet
                            data={data.Actualizacion_Educacion}
                            name="Educación"
                          >
                            <ExcelColumn
                              label="Código de empleado"
                              value="codigo_empleado"
                            />
                            <ExcelColumn
                              label="Info tipo"
                              value={() => "0022"}
                            />
                            <ExcelColumn label="Subtipo" value="subtipo" />
                            <ExcelColumn
                              label="De"
                              value={(col) =>
                                moment(col.fecha_inicio).format("DD.MM.YYYY")
                              }
                            />
                            <ExcelColumn
                              label="Hasta"
                              value={(col) =>
                                moment(col.fecha_fin).format("DD.MM.YYYY")
                              }
                            />
                            <ExcelColumn label="Formación" value="formacion" />
                            <ExcelColumn label="Instituto" value="instituto" />
                            <ExcelColumn
                              label="Clave de país"
                              value={() => "HN"}
                            />
                            <ExcelColumn label="Título" value="titulo" />
                            <ExcelColumn
                              label="Especialidad"
                              value="especialidad"
                            />
                            <ExcelColumn label="Fecha" value="fecha" />
                          </ExcelSheet>
                        )}
                      </ExcelFile>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                      <h6 className="m-0">Exportar estado civil</h6>
                      <ExcelFile
                        element={
                          <Button
                            disabled={
                              !data.Actualizacion_Estado_Civil ||
                              data?.Actualizacion_Estado_Civil?.length === 0
                            }
                            variant="primary"
                            size="sm"
                            onClick={()=> onUpdateStateAdminSettings("estado_civil",data.Actualizacion_Estado_Civil)} 
                          >
                            Exportar
                          </Button>
                        }
                      >
                        {data.Actualizacion_Estado_Civil && (
                          <ExcelSheet
                            data={data.Actualizacion_Estado_Civil}
                            name="Estado civil"
                          >
                            <ExcelColumn
                              label="Código de empleado"
                              value="codigo_empleado"
                            />
                            <ExcelColumn
                              label="Info tipo"
                              value={() => "0002"}
                            />
                            <ExcelColumn
                              label="Estado civil"
                              value="estado_civil"
                            />
                            <ExcelColumn label="Fecha" value="fecha" />
                          </ExcelSheet>
                        )}
                      </ExcelFile>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                      <h6 className="m-0">Exportar capacitación</h6>
                      <ExcelFile
                        element={
                          <Button
                            disabled={
                              !data.actualizacio_capacitacion ||
                              data?.actualizacio_capacitacion?.length === 0
                            }
                            variant="primary"
                            size="sm"
                            onClick={()=> onUpdateStateAdminSettings("capacitacion",data.actualizacio_capacitacion)} 
                          >
                            Exportar
                          </Button>
                        }
                      >
                        {data.actualizacio_capacitacion && (
                          <ExcelSheet
                            data={data.actualizacio_capacitacion}
                            name="Contactos"
                          >
                            <ExcelColumn
                              label="Código de empleado"
                              value="codigo_empleado"
                            />
                            {/* <ExcelColumn label="Info tipo" value={ () => '0021'} /> */}
                            <ExcelColumn label="Info tipo" value="info_tipo" />
                            <ExcelColumn label="Subtipo" value="subtipo" />
                            <ExcelColumn
                              label="De"
                              value={(col) =>
                                moment(col.fecha_inicio).format("DD.MM.YYYY")
                              }
                            />
                            <ExcelColumn
                              label="Hasta"
                              value={(col) =>
                                moment(col.fecha_fin).format("DD.MM.YYYY")
                              }
                            />
                            <ExcelColumn label="Formación" value="formacion" />
                            <ExcelColumn label="Instituto" value="instituto" />
                            <ExcelColumn
                              label="Clave de país"
                              value={() => "HN"}
                            />
                            <ExcelColumn label="Título" value="titulo" />
                            <ExcelColumn
                              label="Especialidad"
                              value="especialidad"
                            />
                            <ExcelColumn label="Fecha" value="fecha" />
                          </ExcelSheet>
                        )}
                      </ExcelFile>
                    </ListGroup.Item>
                  </ListGroup>
                )
              )}
            </div>
            {loading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : (
              <Form onSubmit={onSubmit} noValidate validated={validated}>
                <h6 className="mb-4">
                  Configurar alertas de campaña de actualización de datos.
                </h6>
                <Form.Group as={Row} className="mb-3" controlId="startDate">
                  <Form.Label column sm="12" md="3">
                    Fecha de inicio
                  </Form.Label>
                  <Col sm="12" md="9">
                    <Form.Control
                      defaultValue={
                        dates && dates.fecha_inicio
                          ? dates.fecha_inicio
                          : new Date()
                      }
                      name="startDate"
                      required
                      type="date"
                      placeholder="Fecha de inicio"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="endDate">
                  <Form.Label column sm="12" md="3">
                    Fecha de finalización
                  </Form.Label>
                  <Col sm="12" md="9">
                    <Form.Control
                      defaultValue={
                        dates && dates.fecha_fin ? dates.fecha_fin : new Date()
                      }
                      name="endDate"
                      required
                      type="date"
                      placeholder="Fecha de final"
                    />
                  </Col>
                </Form.Group>
                <div className="my-4 mr-2 text-right">
                  <Button
                    className="rounded-pill"
                    disabled={saveLoading}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoading ? (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : null}
                    Guardar
                  </Button>
                </div>
              </Form>
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default AdminSettings;
